module.exports = __webpack_public_path__ + "img/vip_chat.86f1dcea.svg";